import { axiosService } from '.';
import { BusinessOrder } from '@/models/orders/business-order';

export default class BusinessOrdersService {
    public async getBusinessOrder(businessOrderId: number): Promise<BusinessOrder> {
        const businessOrderData = (await axiosService.instance.get(`orders/businesses/organization/${businessOrderId}`)).data;
        return new BusinessOrder(businessOrderData ? businessOrderData : { businessOrderId });
    }

    public async updateBusinessOrderViewed(businessOrderId: number, businessId: number, viewed: boolean): Promise<boolean> {
        return (await axiosService.instance.post(`orders/businesses/organization/${businessOrderId}/update-viewed?businessId=${businessId}&viewed=${viewed}`)).data;
    }
}

export const businessOrdersService = new BusinessOrdersService();
